<div class="form-container por-signup">
    <h2 class="theme-header">{{ 'Register/Sign Up' | translate }}</h2>
    <form [formGroup]="signupForm" (ngSubmit)="signup()" novalidate>
        <apx-form-field
            label="{{ 'FirstName' | translate }}"
            class="apx-input-container d-inline-flex mb-sm"
            [error]="firstName.invalid && (firstName.dirty || firstName.touched) ? 
            firstName.errors?.['required'] ? ('PleaseEnterYourName' | translate) : 
            firstName.errors?.['maxlength'] ? ('max_128_chars_permitted' | translate):'' 
            : '' ">
            <apx-input-group>
                <span apxPrefix class="flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="16" height="16" fill="currentColor">
                        <g transform="translate(-1.731 -1)">
                            <circle cx="3.169" cy="3.169" r="3.169" transform="translate(8.305 4)" />
                            <path
                                d="M5.731,23.073V21.621a2.89,2.89,0,0,1,1.106-2.308,7.7,7.7,0,0,1,4.634-1.447,7.706,7.706,0,0,1,4.638,1.448,2.89,2.89,0,0,1,1.107,2.308v1.454A1.016,1.016,0,0,1,16.2,24.092H6.75a1.018,1.018,0,0,1-1.019-1.018Z"
                                transform="translate(0 -6.472)" />
                        </g>
                    </svg>
                </span>
                <input
                    porAddFeature
                    featureName="signup-firstName-input"
                    apxInput
                    type="text"
                    formControlName="firstName"
                    autocomplete="on"
                    name="firstName"
                    placeholder="{{ 'EnterYourName' | translate }}"
                    class="theme-input" />
            </apx-input-group>
        </apx-form-field>
        <apx-form-field
            label="{{ 'LastName' | translate }}"
            class="apx-input-container d-inline-flex mb-sm"
            [error]="lastName.invalid && (lastName.dirty || lastName.touched) ? 
            lastName.errors?.['required'] ? ('PleaseEnterYourName' | translate) : 
            lastName.errors?.['maxlength'] ? ('max_128_chars_permitted' | translate):'' 
            : '' ">
            <apx-input-group>
                <span apxPrefix class="flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="16" height="16" fill="currentColor">
                        <g transform="translate(-1.731 -1)">
                            <circle cx="3.169" cy="3.169" r="3.169" transform="translate(8.305 4)" />
                            <path
                                d="M5.731,23.073V21.621a2.89,2.89,0,0,1,1.106-2.308,7.7,7.7,0,0,1,4.634-1.447,7.706,7.706,0,0,1,4.638,1.448,2.89,2.89,0,0,1,1.107,2.308v1.454A1.016,1.016,0,0,1,16.2,24.092H6.75a1.018,1.018,0,0,1-1.019-1.018Z"
                                transform="translate(0 -6.472)" />
                        </g>
                    </svg>
                </span>
                <input
                    porAddFeature
                    featureName="signup-lastName-input"
                    apxInput
                    type="text"
                    formControlName="lastName"
                    autocomplete="on"
                    name="lastName"
                    placeholder="{{ 'EnterYourName' | translate }}"
                    class="theme-input" />
            </apx-input-group>
        </apx-form-field>
        <apx-form-field
            label="{{ 'Company Name (optional)' | translate }}"
            class="apx-input-container d-inline-flex mb-sm"
            [error]="companyName.invalid && (companyName.dirty || companyName.touched) ? 
            companyName.errors?.['maxlength'] ? ('max_128_chars_permitted' | translate):'' 
            : '' ">
            <apx-input-group>
                <span apxPrefix class="flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="16" height="16" fill="currentColor">
                        <g transform="translate(0 1)">
                            <path
                                d="M5.425,2a.713.713,0,0,0-.713.713V15.542H4.356a.356.356,0,1,0,0,.713h3.92V14.117a.713.713,0,0,1,.713-.713h1.425a.713.713,0,0,1,.713.713v2.138h3.92a.356.356,0,0,0,0-.713h-.356V2.713A.713.713,0,0,0,13.978,2ZM7.207,4.138a.356.356,0,0,0-.356.356v.713a.356.356,0,0,0,.356.356H7.92a.356.356,0,0,0,.356-.356V4.495a.356.356,0,0,0-.356-.356ZM6.851,6.633a.356.356,0,0,1,.356-.356H7.92a.356.356,0,0,1,.356.356v.713A.356.356,0,0,1,7.92,7.7H7.207a.356.356,0,0,1-.356-.356Zm.356,1.782a.356.356,0,0,0-.356.356v.713a.356.356,0,0,0,.356.356H7.92a.356.356,0,0,0,.356-.356V8.771a.356.356,0,0,0-.356-.356Zm-.356,2.495a.356.356,0,0,1,.356-.356H7.92a.356.356,0,0,1,.356.356v.713a.356.356,0,0,1-.356.356H7.207a.356.356,0,0,1-.356-.356ZM9.346,4.138a.356.356,0,0,0-.356.356v.713a.356.356,0,0,0,.356.356h.713a.356.356,0,0,0,.356-.356V4.495a.356.356,0,0,0-.356-.356ZM8.989,6.633a.356.356,0,0,1,.356-.356h.713a.356.356,0,0,1,.356.356v.713a.356.356,0,0,1-.356.356H9.346a.356.356,0,0,1-.356-.356Zm.356,1.782a.356.356,0,0,0-.356.356v.713a.356.356,0,0,0,.356.356h.713a.356.356,0,0,0,.356-.356V8.771a.356.356,0,0,0-.356-.356Zm-.356,2.495a.356.356,0,0,1,.356-.356h.713a.356.356,0,0,1,.356.356v.713a.356.356,0,0,1-.356.356H9.346a.356.356,0,0,1-.356-.356Zm2.495-6.771a.356.356,0,0,0-.356.356v.713a.356.356,0,0,0,.356.356H12.2a.356.356,0,0,0,.356-.356V4.495a.356.356,0,0,0-.356-.356Zm-.356,2.495a.356.356,0,0,1,.356-.356H12.2a.356.356,0,0,1,.356.356v.713A.356.356,0,0,1,12.2,7.7h-.713a.356.356,0,0,1-.356-.356Zm.356,1.782a.356.356,0,0,0-.356.356v.713a.356.356,0,0,0,.356.356H12.2a.356.356,0,0,0,.356-.356V8.771a.356.356,0,0,0-.356-.356Zm-.356,2.495a.356.356,0,0,1,.356-.356H12.2a.356.356,0,0,1,.356.356v.713a.356.356,0,0,1-.356.356h-.713a.356.356,0,0,1-.356-.356Z"
                                fill-rule="evenodd" />
                            <path d="M12.425,21.138V19H11v2.138Z" transform="translate(-2.011 -4.883)" />
                        </g>
                    </svg>
                </span>
                <input
                    porAddFeature
                    featureName="signup-company-name-input"
                    apxInput
                    type="text"
                    formControlName="companyName"
                    autocomplete="on"
                    name="companyName"
                    placeholder="{{ 'EnterYourCompanyName' | translate }}"
                    class="theme-input" />
            </apx-input-group>
        </apx-form-field>
        <div class="form-field">
            <label for="">{{ 'Phone Number' | translate }}</label>
            <por-intl-tel-input
                [cssClass]="'country-code'"
                [preferredCountries]="['us']"
                [enableAutoCountrySelect]="false"
                [enablePlaceholder]="true"
                [searchCountryFlag]="true"
                [selectFirstCountry]="true"
                [maxLength]="15"
                [phoneValidation]="true"
                [separateDialCode]="true"
                [required]="true"
                formControlName="phoneNumber"
                porAddFeature
                featureName="signup-phone-number-input"
                [styleInput]="'phone-input-style'"></por-intl-tel-input>
        </div>
        <apx-form-field
            label="{{ 'Email' | translate }}"
            class="apx-input-container d-inline-flex mb-sm"
            [error]="username.invalid && (username.dirty || username.touched) ? 
            username.errors?.['required'] ? ('Please enter username.' | translate) : 
            username.errors?.['email'] ? ('Please enter valid email.' | translate) : 
            username.errors?.['maxlength'] ? ('max_128_chars_permitted' | translate):'' 
            : '' ">
            <apx-input-group>
                <span apxPrefix porIcon icon="email"></span>
                <input
                    porAddFeature
                    featureName="signup-email-input"
                    apxInput
                    formControlName="username"
                    type="email"
                    autocomplete="on"
                    name="username"
                    placeholder="{{ 'Enter your email' | translate }}"
                    class="theme-input" />
            </apx-input-group>
        </apx-form-field>
        <apx-form-field
            label="{{ 'Password' | translate }}"
            class="apx-input-container d-inline-flex mb-sm"
            [error]="password.invalid && (password.dirty || password.touched) ? 
            password.errors?.['required'] ? ('Please enter password.' | translate) : 
            password.errors?.['minlength'] ? ('Password minimum length should be 6.' | translate) : 
            password.errors?.['maxlength'] ? ('max_50_chars_permitted' | translate):'' 
            : '' ">
            <apx-input-group>
                <span apxPrefix porIcon icon="lock"></span>
                <input
                    porAddFeature
                    featureName="signup-password-input"
                    apxInput
                    formControlName="password"
                    type="password"
                    name="password"
                    autocomplete="on"
                    placeholder="{{ 'Enter your password' | translate }}"
                    class="theme-input"
                    maxlength="50" />
            </apx-input-group>
        </apx-form-field>

        <por-privacy-terms [privacyPolicyAccepted]="privacyPolicyAccepted" [formGroup]="signupForm" />

        <button
            porAddFeature
            featureName="signup-signup-button"
            class="btn-primary btn-full-width theme-button"
            type="submit"
            apxButton
            variant="primary"
            [disabled]="signupForm.pristine || signupForm.invalid || isDisableButton">
            {{ 'Sign Up' | translate }}
        </button>
    </form>
    <p class="left-align theme-paragraph">
        {{ 'Already have an account?' | translate }}
        <a porAddFeature featureName="signup-signin-button" href="#" (click)="setTemplate('signin')" class="theme-anchor">{{ 'Sign in here' | translate }}</a>
    </p>
</div>
